import { Component, inject } from '@angular/core';
import { FolderEPrescriptionDetailStore } from './folder-e-prescription-detail.store';

@Component({
    selector: 'app-folder-e-prescription-detail',
    templateUrl: 'folder-e-prescription-detail.component.html',
    styleUrl: 'folder-e-prescription-detail.component.scss',
    providers: [FolderEPrescriptionDetailStore],
    imports: []
})
export class FolderEPrescriptionDetailComponent {

    public readonly store = inject(FolderEPrescriptionDetailStore);

}
